import { Cadence, LenderVariant, RecoveryPath, ScreenId, SeasoningReason, WithdrawReason } from '../types/withdraw';

export const loanHeader = {
  borrower: 'Jane Sample',
  initials: 'JS',
  loanNumber: 'TEST-000123',
  stage: 'Processing',
};

export const lenderNames: Record<LenderVariant, string> = {
  sync: 'UWM',
  nonsync: 'Sample Bank',
};

export const lenderVariants: { id: LenderVariant; label: string }[] = [
  { id: 'sync', label: 'UWM sync' },
  { id: 'nonsync', label: 'Non-sync' },
];

export const screens: { id: ScreenId; label: string }[] = [
  { id: 'path', label: 'Path' },
  { id: 'dead', label: 'Withdraw' },
  { id: 'seasoning', label: 'Seasoning' },
  { id: 'success', label: 'Confirm' },
];

export const recoveryPaths: {
  id: RecoveryPath;
  tag: string;
  title: string;
  description: string;
  meta: string[];
}[] = [
  {
    id: 'dead',
    tag: 'Dead',
    title: 'Withdraw',
    description: 'This file is closed out. It leaves your pipeline and is reported for HMDA.',
    meta: ['Leaves pipeline', 'HMDA reported'],
  },
  {
    id: 'seasoning',
    tag: 'Workable',
    title: 'Enroll in Loan Seasoning',
    description: "Not today, but not never. Park it in the Retention lane with scheduled follow-ups.",
    meta: ['Retention lane', 'Auto follow-ups'],
  },
];

export const withdrawReasons: WithdrawReason[] = [
  'Borrower Backed Out',
  'Borrower Unresponsive',
  'DTI/Credit/LTV Issue',
  'Does Not Qualify',
  'Went With Another Lender',
];

export const hmdaByReason: Record<WithdrawReason, { code: number; label: string }> = {
  'Borrower Backed Out': { code: 4, label: 'Withdrawn by applicant' },
  'Borrower Unresponsive': { code: 5, label: 'File closed for incompleteness' },
  'DTI/Credit/LTV Issue': { code: 3, label: 'Application denied' },
  'Does Not Qualify': { code: 3, label: 'Application denied' },
  'Went With Another Lender': { code: 4, label: 'Withdrawn by applicant' },
};

export const seasoningReasons: { id: SeasoningReason; description: string }[] = [
  { id: 'Rate Watch', description: "We'll flag this loan when rates reach the borrower's target." },
  { id: 'Credit Repair', description: "We'll check back as the borrower works toward a qualifying score." },
  { id: 'Forbearance', description: "Follow-ups pause until the forbearance period wraps up." },
  { id: 'Loan Modification', description: 'Follow-ups pause until the modification is expected to finish.' },
  { id: 'Loan Seasoning', description: 'The existing loan needs more time on the books before it qualifies.' },
];

export const seasoningTypes = [
  'Cash-out refinance (12 months)',
  'Rate/term refinance (6 months)',
  'FHA Streamline (210 days)',
  'VA IRRRL (210 days)',
];

export const cadenceOptions: { id: Cadence; label: string; phrase: string }[] = [
  { id: 'weekly', label: 'Weekly', phrase: 'every week' },
  { id: 'biweekly', label: '2 weeks', phrase: 'every 2 weeks' },
  { id: 'monthly', label: 'Monthly', phrase: 'every month' },
];
